import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/api';
import './CommentSection.css';


const CommentSection = ({ postSlug }) => {
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState({
        author_name: '',
        author_email: '',
        content: ''
    });
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        fetchComments();
    }, [postSlug]);

    const fetchComments = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/posts/${postSlug}/comments/`);
            if (!response.ok) {
                throw new Error('Error al cargar los comentarios');
            }
            const data = await response.json();
            setComments(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching comments:', error);
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const response = await fetch(`${API_BASE_URL}/api/posts/${postSlug}/comments/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newComment),
            });

            if (response.ok) {

                setNewComment({
                    author_name: '',
                    author_email: '',
                    content: ''
                });


                fetchComments();


                alert('¡Comentario enviado! Será visible después de su aprobación.');
            } else {
                alert('Error al enviar el comentario. Por favor, intenta nuevamente.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error de conexión. Por favor, intenta nuevamente.');
        } finally {
            setSubmitting(false);
        }
    };

    const handleChange = (e) => {
        setNewComment({
            ...newComment,
            [e.target.name]: e.target.value
        });
    };

    if (loading) {
        return <div className="loading">Cargando comentarios...</div>;
    }

    return (
        <div className="comments-section">
            <h3>Comentarios ({comments.length})</h3>

            {comments.length === 0 ? (
                <p className="no-comments">No hay comentarios todavía. ¡Sé el primero en comentar!</p>
            ) : (
                <div className="comments-list">
                    {comments.map(comment => (
                        <div key={comment.id} className="comment">
                            <div className="comment-header">
                                <strong className="comment-author">{comment.author_name}</strong>
                                <span className="comment-date">
                                    {new Date(comment.created_at).toLocaleDateString('es-ES', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </span>
                            </div>
                            <p className="comment-content">{comment.content}</p>
                        </div>
                    ))}
                </div>
            )}

            <div className="comment-form-container">
                <h4>Deja tu comentario</h4>
                <form onSubmit={handleSubmit} className="comment-form">
                    <div className="form-group">
                        <input
                            type="text"
                            name="author_name"
                            placeholder="Tu nombre *"
                            value={newComment.author_name}
                            onChange={handleChange}
                            required
                            maxLength="100"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="email"
                            name="author_email"
                            placeholder="Tu email (no se publicará) *"
                            value={newComment.author_email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="content"
                            placeholder="Tu comentario *"
                            rows="4"
                            value={newComment.content}
                            onChange={handleChange}
                            required
                            maxLength="1000"
                        />
                    </div>
                    <button
                        type="submit"
                        className="submit-button"
                        disabled={submitting}
                    >
                        {submitting ? 'Enviando...' : 'Enviar comentario'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CommentSection;